const RGB = /^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/
const HEX = /^#?([0-9a-f]{3,8})$/i

const pad = (value: number) => Math.max(0, Math.min(255, value)).toString(16).padStart(2, '0')

export function toHexColor(color?: string): string | undefined {
    if (!color) return undefined

    const rgb = color.trim().match(RGB)

    if (rgb) {
        return `#${pad(Number(rgb[1]))}${pad(Number(rgb[2]))}${pad(Number(rgb[3]))}`
    }

    const hex = color.trim().match(HEX)

    if (!hex) return undefined

    const digits = hex[1]!

    // Shorthand, with or without its alpha nibble: #abc / #abcd
    if (digits.length === 3 || digits.length === 4) {
        return `#${digits.slice(0, 3).split('').map(digit => digit + digit).join('')}`.toLowerCase()
    }

    if (digits.length === 6 || digits.length === 8) {
        return `#${digits.slice(0, 6)}`.toLowerCase()
    }

    return undefined
}
